import { HttpEvent, HttpHandlerFn, HttpParameterCodec, HttpParams, HttpRequest } from "@angular/common/http";
import { inject, Inject } from "@angular/core";
import { Router } from "@angular/router";
import moment from "moment";
import { Observable, of, throwError } from "rxjs";
import { LoginService } from "../services/login/login.service";

  export function validateSesionInterceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
    const  loginService = inject( LoginService );
    const router =  inject(Router);
    const aux = req.url.includes( 'search' );
    if(  aux ){
      if( loginService.isLoggedIn() ){
        return next(req);
      }else{
        router.navigate(['/']);
        return throwError({error: 'Expired sesión' });
      }
    }
    return next(req);

  }


